/**
 * @generated SignedSource<<ea97a92f6005d58c6846b54e8433cc39>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type VideoDetailsDeleteMutation$variables = {
  id: string;
};
export type VideoDetailsDeleteMutation$data = {
  readonly deleteVideo: {
    readonly id: string;
  };
};
export type VideoDetailsDeleteMutation = {
  response: VideoDetailsDeleteMutation$data;
  variables: VideoDetailsDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "AuthorizedEvent",
    "kind": "LinkedField",
    "name": "deleteVideo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VideoDetailsDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VideoDetailsDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "76fe9bddb39eccfdd40be42a86383b07",
    "id": null,
    "metadata": {},
    "name": "VideoDetailsDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation VideoDetailsDeleteMutation(\n  $id: ID!\n) {\n  deleteVideo(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c121ca44f66f0ac728fc25ae29ba8781";

export default node;
